var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.214844,
    y: 0.5,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#E3E9FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2172 17.0953C16.5486 17.0953 16.8172 16.8267 16.8172 16.4953C16.8172 16.1639 16.5486 15.8953 16.2172 15.8953C15.8858 15.8953 15.6172 16.1639 15.6172 16.4953C15.6172 16.8267 15.8858 17.0953 16.2172 17.0953Z",
    stroke: "#1638B1",
    strokeWidth: 1.54286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2172 12.8953C16.5486 12.8953 16.8172 12.6267 16.8172 12.2953C16.8172 11.9639 16.5486 11.6953 16.2172 11.6953C15.8858 11.6953 15.6172 11.9639 15.6172 12.2953C15.6172 12.6267 15.8858 12.8953 16.2172 12.8953Z",
    stroke: "#1638B1",
    strokeWidth: 1.54286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2172 21.2953C16.5486 21.2953 16.8172 21.0267 16.8172 20.6953C16.8172 20.3639 16.5486 20.0953 16.2172 20.0953C15.8858 20.0953 15.6172 20.3639 15.6172 20.6953C15.6172 21.0267 15.8858 21.2953 16.2172 21.2953Z",
    stroke: "#1638B1",
    strokeWidth: 1.54286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.783043bcbc265cc11cf005afed0e94d0.svg";
export { ForwardRef as ReactComponent };